import { IPropertySearchParameters } from '@stores/Property/types';

export function getPropertySearchParams(
  queryParams: URLSearchParams,
  defaultFilter?: string
): IPropertySearchParameters {
  return {
    tipo: queryParams.get('tipoImovel') || undefined,
    quartos: queryParams.get('quartos') || undefined,
    suites: queryParams.get('suites') || undefined,
    cidade: queryParams.get('cidade') || undefined,
    operacao: defaultFilter || queryParams.get('operacao') || undefined,
    val_min: queryParams.get('valorMin') || undefined,
    val_max: queryParams.get('valorMax') || undefined,
    q: queryParams.get('termo') || undefined,
    page: queryParams.get('page')
      ? parseInt(queryParams.get('page') as string, 10)
      : undefined
  };
}
